import product from './product'
import untils from './untils'
import link from './link'
import callWeixin from './callWeixin'
export default {
  product,
  untils,
  link,
  callWeixin
}



// WEBPACK FOOTER //
// ./src/api/index.js